module.exports = __webpack_public_path__ + "static/media/4735b3b3-a290-4fd0-b8af-3b64fceb965b.6a5349c8.jpg";